export enum GPGKeyStatus {
  active = 'ACTIVE',
  revoked = 'REVOKED',
  expired = 'EXPIRED',
}

export interface GPGKeyResponse {
  id: string;
  key_id: string;
  fingerprint: string;
  public_key: string;
  key_name: string;
  key_email: string;
  status: GPGKeyStatus;
  expires_at: string | null;
  created_at: string;
  last_used_at: string | null;
  is_active: boolean;
  is_expired: boolean;
}

export interface GPGKeyGenerationResponse extends GPGKeyResponse {}

export interface GPGKey {
  id: string;
  keyId: string;
  fingerprint: string;
  publicKey: string;
  keyName: string;
  keyEmail: string;
  status: GPGKeyStatus;
  expiresAt: string | null;
  createdAt: string;
  lastUsedAt: string | null;
  isActive: boolean;
  isExpired: boolean;
}

export interface GenerateGPGKeyRequest {
  keyLength: number;
  expiresInDays: number | null;
}
